export default function PercentageIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.75 2.25L2.25 15.75M16.5 13.875C16.5 15.3247 15.3247 16.5 13.875 16.5C12.4253 16.5 11.25 15.3247 11.25 13.875C11.25 12.4253 12.4253 11.25 13.875 11.25C15.3247 11.25 16.5 12.4253 16.5 13.875ZM6.75 4.125C6.75 5.57475 5.57475 6.75 4.125 6.75C2.67525 6.75 1.5 5.57475 1.5 4.125C1.5 2.67525 2.67525 1.5 4.125 1.5C5.57475 1.5 6.75 2.67525 6.75 4.125Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
}
